/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {

    "use strict";

    export interface IDealerwareMenuFactory {
        toggleSelectSection ( section: any )            : void;
        isSectionSelected   ( section: any )            : any;
        selectPage          ( section: any, page: any ) : void;
    }

    export class DealerwareMenuFactory implements IDealerwareMenuFactory {

        public static $inject:string[ ] = [
            '$location'
        ];

        public openedSection: any;
        public currentPage: any;
        public currentSection: any;

        constructor(
            public $location: any
        ) {

        }

        public toggleSelectSection ( section: any ) : void {
            this.openedSection = (this.openedSection === section ? null : section);
        }

        public isSectionSelected ( section: any ) : boolean {
            return this.openedSection === section;
        }

        public selectPage ( section: any, page: any ) : void {
            page && page.url && this.$location.path(page.url);
            this.currentSection = section;
            this.currentPage = page;
        }
    }

    getDealerwareWebComponentsModule().factory(
        'DealerwareMenuFactory',
        ( $location: any ) => new DealerwareMenuFactory ($location)
    );


    export class DealerwareMenuLinkDirectiveController {

        public static $inject : string[ ] = [
            '$element',
            '$scope',
            '$state'
        ];

        public section      : any;

        constructor (
            public $element : ng.IAugmentedJQuery,
            public $scope   : ng.IScope,
            public $state   : any
        ) {

            // Custom events attached to a link.
            //
            if (this.section.events !== undefined) {

                if (this.section.events.click !== undefined) {
                    this.$element.bind('click', this.section.events.click);
                }
                if ( this.section.events.show !== undefined &&
                    ! this.section.events.show.call()
                ) {
                    this.$element.hide();
                }
            }
        }

        // Routing state string returned for ui-sref.
        //
        public getPageRouteState ( pageData: any ) : string {

            if ( pageData.state !== undefined
                 && this.$state.get(pageData.state)
               ) {

                var state       = this.$state.get(pageData.state);
                var stateData   = this.normalizeStateData(state);

                if (! stateData.absoluteUrl) {
                    return pageData.state;
                }
            }

            return null;
        }

        // Literal relative or absolute URLs returned for href string.
        // Needed for e.g. links to external sites such as the Dealerware
        // schoolkeep training site.
        //
        // We can also get back a function  for stateData.url to send in
        // params to the routing configuration and get back a dynamic
        // URL.
        //
        // absoluteUrl is configured in routing along with this state string.
        //
        public getPageUrl ( pageData: any ) : string {

            if ( pageData.state !== undefined
                 && this.$state.get(pageData.state)
               ) {

                var state       = this.$state.get(pageData.state);
                var stateData   = this.normalizeStateData(state);

                if (stateData.absoluteUrl) {
                    return typeof stateData.url === 'function' ?
                        stateData.url(pageData.stateArgs) : stateData.url;
                }
            }

            return null;
        }

        // Link target string used only for external sites.
        // e.g. training.
        //
        public getPageTarget ( pageData : any ) : string {

            if ( pageData.state !== undefined
                 && this.$state.get(pageData.state)
               ) {

                var state = this.$state.get(pageData.state);

                if (this.normalizeStateData(state).newWindow) {
                    return '_blank';
                }
            }

            return '_self';
        }

        private normalizeStateData ( state : any ) : any {

            return state.data && state.data.target ?
                this.$state.get(state.data.target).data || { } :
                state.data || { };
        }
    }

    getDealerwareWebComponentsModule().controller(
        'DealerwareMenuLinkDirectiveController',
        DealerwareMenuLinkDirectiveController
    );


    export class DealerwareMenuLinkDirective implements ng.IDirective {

        public restrict         : string    =   'E';
        public controller       : any       =   'DealerwareMenuLinkDirectiveController';
        public controllerAs     : string    =   'dealerwareMenuLinkDirectiveController';
        public bindToController : boolean   =   true;
        public scope            : Object    =   {
            section: '='
        };
        public templateUrl      : string    =   '/components/menu-tree/link.html';
    }

    getDealerwareWebComponentsModule().directive(
        'menuLink',
        ( ) => new DealerwareMenuLinkDirective()
    );


    export class DealerwareMenuModalDirectiveController {
        public static $inject: string[] = [
            '$element',
            '$mdDialog'
        ];

        public section: any;

        constructor(public $element: ng.IAugmentedJQuery,
                    public $mdDialog: any) {
            var events = this.section.events;

            if (events !== undefined) {
                if (events.click !== undefined) {
                    this.$element.bind('click', events.click);
                }
                if (events.show !== undefined && events.show.call()) {
                    this.$element.hide();
                }
            }
        }

        showModal() : void {
            this.$mdDialog.show(this.section.modal);
        }
    }

    getDealerwareWebComponentsModule().controller(
        'DealerwareMenuModalDirectiveController',
        DealerwareMenuModalDirectiveController
    );

    export class DealerwareMenuModalDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'DealerwareMenuModalDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public scope            : Object    =   {
            section: '='
        };
        public templateUrl      : string    =   '/components/menu-tree/modal.html';
    }

    getDealerwareWebComponentsModule().directive(
        'menuModal',
        () => new DealerwareMenuModalDirective()
    );


    export class DealerwareSubparentMenuDirectiveController {

        public static $inject : string[ ] = [
            '$element',
            '$scope',
            '$state',
            'DealerwareMenuFactory'
        ];

        public section      : any;

        constructor(
            public $element : ng.IAugmentedJQuery,
            public $scope   : ng.IScope,
            public $state   : any,
            public menu     : IDealerwareMenuFactory
        ) {

            if (this.section.events !== undefined) {
                if (this.section.events.click !== undefined) {
                    this.$element.bind('click', this.section.events.click);
                }
                if ( this.section.events.show !== undefined &&
                     ! this.section.events.show.call()
                ) {
                    this.$element.hide();
                }
            }

            var parentNode = <Element>this.$element[0].parentNode.parentNode.parentNode;
            if (parentNode.classList.contains('parent-list-item')) {
                var heading = parentNode.querySelector('h2');
                (<Element>this.$element[0].firstChild).setAttribute('aria-describedby', heading.id);
            }
        }

        public isOpen() : any {
            return this.menu.isSectionSelected(this.section);
        }

        public toggle() : void {
            this.toggleOpen(this.section);
        };

        public toggleOpen(section : any) : void {
            this.menu.toggleSelectSection(section);
        }
    }

    getDealerwareWebComponentsModule().controller(
        'DealerwareSubparentMenuDirectiveController',
        DealerwareSubparentMenuDirectiveController
    );


    export class DealerwareSubparentMenuDirectiveDirective implements ng.IDirective {

        public restrict         : string    =   'E';
        public controller       : any       =   'DealerwareSubparentMenuDirectiveController';
        public controllerAs     : string    =   'dealerwareSubparentMenuDirectiveController';
        public bindToController : boolean   =   true;
        public scope            : Object    =   {
            section: '='
        };
        public templateUrl      : string    =   '/components/menu-tree/submenu-parent.html';
    }

    getDealerwareWebComponentsModule().directive(
        'submenuParent',
        ( ) => new DealerwareSubparentMenuDirectiveDirective()
    );


    getDealerwareWebComponentsModule().filter('humanizeDoc', ( ) => {

        return ( doc: any ) => {
            if (! doc) {
                return;
            }

            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, ( $1: string ) => {
                    return '-' + $1.toLowerCase();
                });
            }

            return doc.label || doc.name;
        };
    });

}
